import React, { useContext, useState } from 'react';

import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import NumericInput from '@common/components/numericInput';
import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';
import Config from '@skin_config';

import './style.scss';

const TransferOnline = () => {
  const t = useTranslation();
  const [value, setValue] = useState('');
  const [{ openPopup, closePopup }] = useContext(PopupContext);

  const findClient = () => {
    const { token } = JSON.parse(sessionStorage.getItem('authData'));
    swarmRequest(
      { token, filter: { id: +value } },
      'terminal_find_player',
    )
      .then((response) => {
        const client = response.data[0];
        if (client) {
          openPopup(POPUPS.FIND_MATCH_POPUP, { client });
        } else {
          openPopup(POPUPS.ERROR_MATCH_POPUP);
        }
      });
  };

  return (
    <div className="popup-content popup-small transfer-online-wrapper">
      <h3 className="popup-title">{t('Search for Online Account')}</h3>
      <i className="global-icon icon-regular-close" onClick={closePopup} />
      <div className="popup-main-content">
        <i className="global-icon icon-profile transfer-icon" />
        <p className="text-center">{t('Search for your online account using your Client ID. Register if you don’t have an account.')}</p>
      </div>
      <div className="popup-actions">
        <div className="search-client-inp-wrapper">
          <p>{t('Enter client id')}</p>
          <NumericInput
            value={value}
            placeholder="Enter client id here"
            onChange={(e) => {
              setValue(e.replace(/[^0-9]/g, ''));
            }}
            className="client-id-inp"
            maxLength={11}
          />
          <button
            type="button"
            className="popup-confirm-button"
            onClick={findClient}
          >
            {t('Search')}
          </button>
        </div>
      </div>
      {
        Config.main.enableRegistration && (
          <div
            className="register"
            onClick={() => openPopup(POPUPS.SIGN_UP)}
          >
            {t('Need an Account?')}
            &nbsp;
            <span>{t('Register')}</span>
          </div>
        )
      }
    </div>
  );
};

export default TransferOnline;
